export const HUBSPOT_OWNER = 'hubspot_owner_id';